import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import MarineList from '../../components/Entity/Marine/List/List';
 
const MarinesPage = () => {
  return <Layout fullwidth={0}>
      <MarineList></MarineList>
  </Layout>;
}

export default MarinesPage;
